// @flow
import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

import InfiniteCalendarSelect from "../../../global/components/InfiniteCalendarSelect";
import {
  CancelButton,
  SubmitButton,
  SingleCheckBox,
  UploadButton
} from "imagus-components";

type UploadInvoiceFilePropsType = {
  billingId: string,
  billingUid: string,
  companyId: string,
  invoice: string | null,
  paidOn: string | null,
  onClose: Funciton,
  uploadFile: Function,
  openSnackbar: Function
};

type UploadInvoiceFileStateType = {
  loading: boolean,
  isPaid: boolean,
  paidOn: Date | null,
  invoice: File | null
};

class UploadInvoiceFile extends Component<
  UploadInvoiceFilePropsType,
  UploadInvoiceFileStateType
> {
  constructor(props: UploadInvoiceFilePropsType) {
    super(props);
    this.state = {
      loading: false,
      isPaid: false,
      paidOn: null,
      invoice: null
    };
  }

  componentDidMount() {
    if (this.props.paidOn) {
      this.setState({ isPaid: true, paidOn: this.props.paidOn });
    }

    if (this.props.invoice) {
      this.setState({ invoice: { name: this.props.invoice } });
    }
  }

  handleCheckBoxChange = (
    e: Event & { currentTarget: HTMLInputElement }
  ): * => {
    this.setState({
      [e.currentTarget.name]: !this.state[e.currentTarget.name]
    });
  };

  syncDateChange = (name: string, date: Date): * => {
    this.setState({ [name]: date });
  };

  uploadFileHandler = (): * => (e: Event): * => {
    let file;
    if (e.dataTransfer) {
      file = e.dataTransfer.files[0];
    } else if (e.target) {
      file = e.target.files[0];
    }
    if (file) {
      this.setState({ invoice: file });
    }
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ loading: true });

    this.props.uploadFile(
      this.props.billingId,
      this.props.billingUid,
      this.state.isPaid ? this.state.paidOn : "",
      this.state.invoice && this.state.invoice.name !== this.props.invoice
        ? this.state.invoice
        : null,
      this.submitDone
    );
  };

  submitDone = () => {
    this.props.openSnackbar(19);
    this.props.onClose();
  };

  render(): React$Element<*> {
    return (
      <form
        onSubmit={(!this.state.loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <SingleCheckBox
                  name="isPaid"
                  value={this.state.isPaid}
                  onChange={this.handleCheckBoxChange}
                  label="Bill Paid?"
                />
              </Grid>
              <Grid item xs={12}>
                {this.state.isPaid && (
                  <InfiniteCalendarSelect
                    isRequired={true}
                    label="Paid Date"
                    name="paidOn"
                    value={this.state.paidOn}
                    syncDateChange={this.syncDateChange}
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">Upload Invoice File</Typography>
                <UploadButton
                  id={"po_file" + this.props.billingId}
                  uploadFileActions={this.uploadFileHandler()}
                  fileType=".pdf"
                  outerClass="inline-btn left-margin-10"
                />
                {this.state.invoice && (
                  <Chip
                    label={this.state.invoice.name}
                    className="left-margin-10"
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <div className="form-right-btn-block">
                  <CancelButton onClick={this.props.onClose} />
                  <SubmitButton loading={this.state.loading} />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

export default UploadInvoiceFile;
